import { render, staticRenderFns } from "./PopupUi.vue?vue&type=template&id=3852b064&scoped=true"
import script from "./PopupUi.vue?vue&type=script&lang=js"
export * from "./PopupUi.vue?vue&type=script&lang=js"
import style0 from "./PopupUi.vue?vue&type=style&index=0&id=3852b064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3852b064",
  null
  
)

export default component.exports